// U20-spezifische Overrides.
//
// Die Basis-Config kommt weiterhin vom Backend (configUrl). Alles was hier
// gesetzt ist, überschreibt den Remote-Wert. Felder auf null lassen den
// Remote-Wert unangetastet.
export default {
  // Kontaktanfrage / Mailversand: geht fest an den sendMail-Endpunkt von
  // universal.dasbad3.de. Der loest per config_id die Handwerker- und
  // Endkunden-Mail aus. Bewusst hier gepinnt, damit es unabhaengig von der
  // Remote-Config immer dorthin geht.
  sendCustomerMailUrl:
    'https://universal.dasbad3.de/universalbackend/public/api/bathconfig/sendMail',

  // Danke-Seite nach erfolgreichem Absenden. Die einbettende Seite führt den
  // Redirect aus (postMessage), der Konfigurator selbst navigiert nicht.
  afterFormSuccessUrl: '/danke-badkonfigurator',
};
